import { render, staticRenderFns } from "./VButtonWide.vue?vue&type=template&id=3e53189b&"
import script from "./VButtonWide.vue?vue&type=script&lang=js&"
export * from "./VButtonWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports